import { render, staticRenderFns } from "./BankFeed.vue?vue&type=template&id=3360be38&"
import script from "./BankFeed.vue?vue&type=script&lang=js&"
export * from "./BankFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports